export default __webpack_public_path__ + "static/media/error-1.6cefb0bf.png";